<template>
    <div class="article-box">

        <div class="pics-list-box white-bg">
            <div class="news-title">
                <span class="h-nav">
                <a href="../personal/index.html">个人网站</a><a href="index.html">企业网站</a><a
                        href="../unit/index.html">事业单位</a><a
                        href="../shop/index.html">网购商城</a></span>
                <h2>企业网站</h2>
            </div>
            <ul>
                <li><a href="69.html"><i><img src="../../assets/images/pic04.jpg"></i>
                    <h2>蓝色企业网站模板超实用，完美符合SEO优化，适合企业公司建站的模板</h2>
                    <p>
                        此模板为全静态页面模板，非原创设计，属于仿站，代码不是扒的，全手工敲的，为的就是保证网站效果的前提下，还要代码精炼，有利于做企业网站优化。页面采用html5+css3，以及响应式布局，都是</p>
                </a></li>
                <li><a href="68.html"><i><img
                        src="https://www.yangqq.com/d/file/qiyewangzhanmuban/2019-02-27/3556363baacfb598d5359c13008f7a00.jpg"></i>
                    <h2>免费紫色婚庆公司企业网站模板</h2>
                    <p>免费紫色婚庆公司企业网站模板,这套模板一共5个页面，首页，列表页，内页，单页等。整套齐全，非响应式布局。这套婚庆公司企业模板，颜色以紫色为主，涉及图片展示以及资讯详情</p></a></li>
                <li><a href="67.html"><i><img
                        src="https://www.yangqq.com/d/file/qiyewangzhanmuban/2019-02-27/c29de6913e83ec7e2ae5ad41e221e77b.jpg"></i>
                    <h2>蓝色集团公司企业网站模板</h2>
                    <p>这是一个蓝色的集团公司企业模板，页面有首页，列表页，内容页，单页。首页二级导航菜单，大图banner，新闻标题切换，公告自下向上滚动，子公司介绍等等</p></a></li>
                <li><a href="66.html"><i><img
                        src="https://www.yangqq.com/d/file/qiyewangzhanmuban/2019-02-27/719aa8704acfb4a3727e6f1c7071441c.jpg"></i>
                    <h2>门户类型装修公司企业网站模板</h2>
                    <p>
                        这是一个门户类型，暖色系的企业网站模板，模块化的设计，技术采用html5+css3，图片切换，信息资讯中心可以侧重来优化网站的关键字词等，整体家装解决方案是一个亮点，通过鼠标滑动切换效果。</p>
                </a></li>
                <li><a href="65.html"><i><img
                        src="https://www.yangqq.com/d/file/qiyewangzhanmuban/2019-02-27/c40720abe2562129ec283575b1595541.jpg"></i>
                    <h2>实用大气的装修公司企业网站模板</h2>
                    <p>这是一个企业公司的模板，运用行业可以是建站公司、装修公司、婚庆策划公司等，颜色主要采用冷色系，企业网站模板的首页设计，都偏向全屏式的布局，主要是为了衬托网站的大气。</p></a></li>
            </ul>

            <div class="pagelist"><a title="Total record">&nbsp;<b>20</b> </a>&nbsp;&nbsp;&nbsp;<b>1</b>&nbsp;<a
                    href="index_2.html">2</a>&nbsp;<a href="index_2.html">下一页</a>&nbsp;<a href="index_2.html">尾页</a>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "Index"
    }
</script>

<style scoped>

</style>